import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Users } from '../pages/layout/list-users/list-users.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { AngularFireAuth } from '@angular/fire/auth';
import { Subject } from 'rxjs';
import axios, { AxiosError, AxiosResponse } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    ) {}

  closeButtonClickEmitter = new Subject<boolean>();
  
  prodApiBase = 'https://w3tbaiuq52.execute-api.us-east-1.amazonaws.com'

  getUsers(){
    return this.afs.collection<Users>(environment.env.EnvBaseUrl+'/'+environment.env.RidersCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Users;
        const id = action.payload.doc.id;
        // return data;
        return { id, ...data };
      });
    });
  }

  getUserData(uid){
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersCollection).doc(uid).snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { id, ...data };
    }));
  }

  getLoginUserData(uid) {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.LoginUsersCollection).doc(uid).snapshotChanges().pipe(
      map(action => {
        const data = action.payload.data();
        const id = action.payload.id;
        return { id, ...data };
      })
    );
  }
  private myFunc: () => void;

  onSomethingHappended(fn: () => void) {
    this.myFunc = fn;
  }

  addUser(data){
    return new Promise<any>((resolve, reject) => {
      return this.afAuth.auth.createUserWithEmailAndPassword(data.Email,'root123').then(
        value => {
          let loginData = {
            UserType: 'Rider',
            Email: data.Email,
          };
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.LoginUsersCollection).doc(value.user.uid).set(loginData);
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersCollection).doc(value.user.uid).set({...data, id:value.user.uid});
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersPaymentDashboardCollection).doc(value.user.uid).set({id:value.user.uid, data:{}});
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.MobileNotificationsCollection).doc(value.user.uid).set({"NotificationsList":[]});
          resolve(value.user.uid);
          this.closeButtonClickEmitter.next(true)
        }
      ).catch(err => {
        let errorMessage=err.message
        if(err.message=="The email address is already in use by another account."){
          errorMessage="The Phone number is already in use by another account"
        }
        this.closeButtonClickEmitter.next(true)
        window.alert(errorMessage);
        
      });
    }).catch(error => {
      this.closeButtonClickEmitter.next(true)
      window.alert(error.message);
    });
  }
  

  editUser(data,id){
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersCollection).doc(id).update(data).then(
        res => {
          this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersPaymentDashboardCollection).doc(id).update(data).then(
            res => {
              resolve(id);
            }, err => reject(err)
          );
        }, err => reject(err)
      );
    });
  }

  deleteUser(user) {
    this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersPaymentDashboardCollection).doc(user.id).delete();
    this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.MobileNotificationsCollection).doc(user.id).delete();
    this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.LoginUsersCollection).doc(user.id).delete();
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RidersCollection).doc(user.id).delete();
  }

  async addRiderUser(userData) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: `${this.prodApiBase}/dev/api/createRider`,
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        data : userData
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async editRiderUser(userData, uid) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'put',
        url: `${this.prodApiBase}/dev/api/updateRider/${uid}`, 
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        data : userData
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

}